// Global brand & theme constants for Wetterdesign.se
export const BRAND = {
  name: "Wetterdesign",
  tagline: "Nästa generations webbyrå",
  email: "hej@wetterdesign.se",
  phone: "+46 70 123 45 67",
  city: "Jönköping",
  region: "Vid Vättern",
  social: {
    instagram: "https://instagram.com/wetterdesign",
    linkedin: "https://linkedin.com/company/wetterdesign",
    behance: "https://behance.net/wetterdesign",
  },
};

export const COLORS = {
  navy: "#0f1d33",
  navySoft: "#1a2c48",
  sand: "#dab884",
  sandSoft: "#f4ead9",
  leather: "#8B5E3C",
  white: "#ffffff",
  ink: "#0B1220",
};

// High-quality Unsplash sources used across the site
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1500964757637-c85e8a162699?auto=format&fit=crop&w=1920&q=80", // Scandinavian lake
  heroAlt:
    "https://images.unsplash.com/photo-1505765050516-f72dcac9c60e?auto=format&fit=crop&w=1920&q=80",
  laptopMockup:
    "https://images.unsplash.com/photo-1517433670267-08bbd4be890f?auto=format&fit=crop&w=1400&q=80", // laptop screen
  phoneMockup:
    "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?auto=format&fit=crop&w=900&q=80",
  laptopScreen:
    "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=1400&q=80",
  phoneScreen:
    "https://images.unsplash.com/photo-1542435503-956c469947f6?auto=format&fit=crop&w=600&q=80",
  team: {
    one: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=600&q=80",
    two: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=600&q=80",
  },
  portfolio: [
    {
      title: "Nordic Café",
      category: "Webbdesign",
      description:
        "En atmosfärisk hemsida för ett nordiskt kafé med online-bokning.",
      image_url:
        "https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1200&q=80",
    },
    {
      title: "Lakeside Boutique",
      category: "E-handel",
      description: "Modern e-handel byggd för upplevelse och konvertering.",
      image_url:
        "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1200&q=80",
    },
    {
      title: "Vätterns Vandring",
      category: "Branding",
      description: "Visuell identitet och digital närvaro för guideföretag.",
      image_url:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80",
    },
    {
      title: "Studio Norra",
      category: "Webbdesign",
      description: "Portfolio-sajt för en arkitektstudio.",
      image_url:
        "https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=1200&q=80",
    },
    {
      title: "Vätterns Mat",
      category: "Branding",
      description: "Förpackningsdesign och webbplats för matproducent.",
      image_url:
        "https://images.unsplash.com/photo-1525909002-1b05e0c869d8?auto=format&fit=crop&w=1200&q=80",
    },
    {
      title: "Northern Lights",
      category: "E-handel",
      description: "Konverteringsoptimerad butik med snabba betalningar.",
      image_url:
        "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?auto=format&fit=crop&w=1200&q=80",
    },
  ],
};

export const NAV_LINKS = [
  { label: "Tjänster", href: "#tjanster" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Om Oss", href: "#om-oss" },
  { label: "Kontakt", href: "#kontakt" },
];
